"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as e } from "react";
import l from "../components/Icon/SvgIcon.js";
const r = (t) => /* @__PURE__ */ o(
  l,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...t,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M21.6 12a9.6 9.6 0 1 1-19.2 0 9.6 9.6 0 0 1 19.2 0m-.384 0a9.216 9.216 0 1 1-18.432 0 9.216 9.216 0 0 1 18.432 0",
        clipRule: "evenodd"
      }
    )
  }
), d = e(r);
export {
  d as Dot,
  d as default
};
